import React,{useEffect,useState} from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle,Button } from "reactstrap";
import Dropzone from "react-dropzone";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {httpGet} from "../../../../src/common/petitions"
import reportes from './model.json'
import "../tables.scss";
import "../Puestos.scss";

const Puestos = () => {
  const [data, setData] = useState(null);
  const [totals, setTotals] = useState(null);
  const [puestos, setPuestos] = useState({});
  
  useEffect(() => {
    // Fetch the JSON data from the server
    const fetchData = async () => {
      try {
        const rowsData = await httpGet('/mod/reportes')
        setPuestos(rowsData)
        // console.log(rowsData,reportes.zafra_normal);
        const jsonData = { "columns": reportes.ccu, "rows": rowsData.resume };
        setData(jsonData);
        setTotals(rowsData.totals);
        // console.log(jsonData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []); 
  const options = {
    // Other MDBDataTable options
    // ...
    // Custom row rendering function with inline styles
    rowClassName: (row) => (row.rowIndex === 0 ? 'style="position: sticky; top: 0; background-color: #f2f2f2;"' : ''),
  };
  document.title = "Mano de obra Directa - Reportes puestos - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Mano de obra directa" title="Reportes generales"  />
          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                <h1>
                  Presupuesto: {totals}
                </h1>
                  <h3>
                    Desgloce por CCU
                  </h3>
                  {data && <MDBDataTable responsive striped bordered data={data} options={options}/>}
                  <h3>
                    Desgloce por semana
                  </h3>
                  {/* {data && <MDBDataTable responsive striped bordered data={[]} />} */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Puestos;
